import { COMPETITION_PRIZE_HANDLES } from '@nandosaus/constants';
import { get, isEqual } from 'lodash';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';

import { Box } from '../../grid';
import { Button } from '../../button';
import { CompetitionPrize } from '../competition-prize';
import { Modal } from '../../modal';
import { navigation } from '../../../constants';

const PrizeModal = ({ entriesAvailable, hasConsentToEmailGuest, userCanEnter, onClose, onSpin, profile, prize }) => {
  const prizeType = get(prize, 'prizeType');

  return (
    <Modal
      analyticsTitle="Spin to Win Congratulations!"
      modalTitle={
        isEqual(prizeType, COMPETITION_PRIZE_HANDLES.GRAND_PRIZE) ? `You’ve won the major prize` : `You’re a winner`
      }
      open
      handleClose={onClose}
      buttons={{
        primary: (
          <Button onClick={userCanEnter ? onSpin : onClose} isFullWidth>
            {userCanEnter ? `Spin Again (${entriesAvailable})` : 'Close'}
          </Button>
        ),
        tertiary: (
          <Button variant="tertiary" href={navigation.MENU} isFullWidth>
            Back to menu
          </Button>
        ),
      }}
    >
      <Box display="flex" alignItems="center" justifyContent="center" flexDirection="column">
        <CompetitionPrize hasConsentToEmailGuest={hasConsentToEmailGuest} prize={prize} profile={profile} />
      </Box>
    </Modal>
  );
};

PrizeModal.propTypes = {
  entriesAvailable: PropTypes.number.isRequired,
  userCanEnter: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSpin: PropTypes.func.isRequired,
  prize: PropTypes.shape({}).isRequired,
  profile: PropTypes.shape({
    email: PropTypes.string,
  }),
  hasConsentToEmailGuest: PropTypes.bool,
};

PrizeModal.defaultProps = {
  hasConsentToEmailGuest: false,
  profile: null,
};

const ComposedPrizeModal = observer(PrizeModal);

export { ComposedPrizeModal as PrizeModal };
